export default "__VITE_ASSET__CmdENZxZ__"